var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-body chat-body"},_vm._l((_vm.messages),function(message){return _c('chat-message',{key:message.id,attrs:{"message":message,"is-own-message":_vm.authId !== message['sender_user_id']}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }